import type { ReactNode } from 'react'
import { H1 } from '../text'

type Props = {
  children?: ReactNode
  title?: string
}

export const Hero = ({ children, title }: Props) => {
  return (
    <header className="section-hero">
      {title && (
        <H1 align="center" fontWeight={900} fontSize="xxxxxl" color="eggplant">
          {title}
        </H1>
      )}
      {children}
    </header>
  )
}
